import { render } from "./EditWarehouses.vue?vue&type=template&id=337d5cdc&scoped=true&ts=true"
import script from "./EditWarehouses.vue?vue&type=script&lang=ts"
export * from "./EditWarehouses.vue?vue&type=script&lang=ts"

import "./EditWarehouses.vue?vue&type=style&index=0&id=337d5cdc&scoped=true&lang=css"

import exportComponent from "/var/jenkins_home/workspace/saas-fulfillment-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-337d5cdc"]])

export default __exports__